var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.typeChart == 'line' ? 'line' :
    _vm.typeChart == 'bar' ? 'bar' :
      _vm.typeChart == 'doughnut' ? 'doughnut' : 'chart'},[_c('canvas',{attrs:{"id":_vm.idChartProp}})])
}
var staticRenderFns = []

export { render, staticRenderFns }